import * as React from 'react';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import FormEditingHandler from 'Containers/FormEditingHandler';
import NutritionForm from './Form';
import { EditHistoryDialogStandAlone } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';

const Nutrition = ({ documents }: IOwnProps): React.JSX.Element => (
  <FormEditingHandler name="nutrition" documents={documents}>
    {(editing, startEdit, formData): React.JSX.Element => {
      const nutritionDocument = documents.length > 0 ? documents[0] : undefined;
      return (
        <DocumentWrapper>
          <DocumentHeader
            name={'nutrition'}
            headerId={'nutrition.title'}
            editing={editing}
            editButtons={[
              <DocumentCreationButton
                key={'creation'}
                name={'nutrition'}
                document={nutritionDocument}
                text={'general.edit'}
                onClick={startEdit(nutritionDocument ?? {})}
              />,
              <EditHistoryDialogStandAlone key={'edit'} document={nutritionDocument} />,
            ]}
          />
          <NutritionForm editing={editing} formData={formData} document={documents[0]} />
        </DocumentWrapper>
      );
    }}
  </FormEditingHandler>
);

interface IOwnProps {
  documents: IDocumentWithTypeV2<'nutrition'>[];
}

export default Nutrition;
